import React from 'react'
import * as commonStyles from '../index.css'
import * as styles from './bigHeaderContent.css'
import { HeadingText, BodyText } from '@paypalcorp/pp-react'
import ProfileCover from './ProfileCover'
import ClosedBadge from './ClosedBadge'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'

interface BigHeaderContentProps {
  groupName: string
  groupDescription: string
  formattedCreatorInfo: any
  isClosed: boolean
}

export const BigHeaderContent = ({
  groupName,
  groupDescription,
  formattedCreatorInfo,
  isClosed,
}: BigHeaderContentProps) => {
  const { getContent } = useLocalizedContent()
  return (
    <div className={styles.topSection} data-testid="topSection">
      <div className={styles.titleContainer} data-testid="bigHeader">
        <HeadingText
          size="lg"
          as="h3"
          className={styles.bigTitle}
          aria-label={getContent('detail.poolName', { groupName })}
        >
          {groupName}
        </HeadingText>
        {isClosed && <ClosedBadge />}
      </div>
      <BodyText
        as="p"
        className={commonStyles.description}
        aria-label={getContent('detail.poolDescription', { groupDescription })}
      >
        {groupDescription}
      </BodyText>
      <ProfileCover creator={formattedCreatorInfo} />
    </div>
  )
}
